<template>
  <div>
    <span v-if="loading">
      <i class="fa fa-circle-o-notch fa-spin" />
    </span>
    <span v-show="! loading">
      <div
        id="tinymce-content"
        v-if="! config.selector"
      />
      <textarea
        :name="config.name"
        :value="value"
        v-else
      />
    </span>
  </div>
</template>

<script>
const invoiceVars = [
  {
    text: 'Primeiro Nome da Empresa',
    value: '{{ company_first_name }}'
  },
  {
    text: 'ID da fatura (Bulldesk)',
    value: '{{ invoice_id }}',
  },
  {
    text: 'URL da fatura (Bulldesk)',
    value: '{{ invoice_url }}',
  },
  {
    text: 'Valor total da fatura',
    value: '{{ invoice_total }}',
  },
  {
    text: 'Status da fatura',
    value: '{{ invoice_status }}',
  },
  {
    text: 'Descrição da fatura',
    value: '{{ invoice_status_description }}',
  },
  {
    text: 'Código de Barras do Boleto',
    value: '{{ invoice_digitable_line }}',
  },
];

export default {
  props: {
    value: {},
    config: {},
    variables: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    value (val, prevVal) {
      if (this.editor && typeof val === 'string' && val !== this.currentContent && val !== prevVal) {
        this.currentContent = val;
        this.editor.setContent(val);
      }
    },
  },

  computed: {
    editor () {
      return tinymce.activeEditor;
    },
  },

  data () {
    return {
      currentContent: '',
      loading: true,
      fields: [],
      default: {
        height: 100,
        selector: '#tinymce-content',
        menubar: false,
        language: this.locale() === 'pt_BR' ? 'pt_BR' : '',
        language_url: this.locale() === 'pt_BR' ? '/build/tinymce/pt_BR.js' : '',
        font_formats: 'Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;Courier New=courier new,courier;Georgia=georgia,palatino;Helvetica=helvetica;Tahoma=tahoma,arial,helvetica,sans-serif;Times New Roman=times new roman,times;Verdana=verdana,geneva;',
        content_css: ['/build/tinymce/skins/lightgray/skin.min.css'],
        theme_url: '/build/tinymce/themes/modern/theme.min.js',
        content_style: '.bulldesk-var-option {cursor: default; background-color: #65b9dd; color: #FFF; padding: 2px 5px; border-radius: 3px; display: inline-block; }',
        automatic_uploads: true,
        images_upload_url: '/file/upload?isFilePublic=true',
        images_reuse_filename: true,
        file_picker_types: 'image',
        variable_class: 'bulldesk-var-option',
        variable_prefix: '{{ ',
        variable_suffix: ' }}',
        variable_mapper: this.fields,

        setup: function (editor) {
          if (this.variables === false) {
            return;
          }

          Bus.$on('fieldsRetrieved', (fields) => {
            const mapped = this.mapFields(fields);

            if (mapped.length) {
              editor.addButton('variables', {
                type: 'listbox',
                text: this.__('Variáveis'),
                values: mapped,
                onselect (e) {
                  e.preventDefault();

                  editor.insertContent(this.value());
                },
              });

              // if we already have rendered it, we have to add the button manually
              if (editor && editor.theme && editor.theme.panel) {
                const bg = editor.theme.panel.find('toolbar buttongroup')[0];

                bg._lastRepaintRect = bg._layoutRect;
                bg.append(editor.buttons.variables);
              }
            }
          });
        }.bind(this),

        init_instance_callback: function (editor) {
          editor.setContent(this.value);

          editor.on('change keyup undo redo objectresized', () => {
            this.currentContent = editor.getContent();
            this.$emit('input', this.currentContent);
          });

          this.loading = false;
        }.bind(this),

        file_picker_callback (cb, value, meta) {
          const input = document.createElement('input');

          input.setAttribute('type', 'file');

          if (meta.filetype === 'image') {
            input.setAttribute('accept', 'image/*');
          } else {
            input.setAttribute('accept', 'image/jpg,image/jpeg,image/gif,image/png,application/pdf,image/x-eps');
          }

          input.onchange = function () {
            const file = this.files[0];

            if (file.size > 1000000) {
              alert(this.__('Tamanho máximo por imagem: 1 MB'));

              return cb('');
            }

            const id = `blobid${(new Date()).getTime()}`;
            const { blobCache } = tinymce.activeEditor.editorUpload;
            const blobInfo = blobCache.create(id, file);

            blobCache.add(blobInfo);

            if (meta.filetype === 'image') {
              cb(blobInfo.blobUri(), { title: file.name });
            }

            if (meta.filetype === 'file') {
              cb(blobInfo.blobUri(), { text: file.name });

              input.click();
            }
          };

          input.click();
        },
      },
    };
  },

  created () {
    document.addEventListener('focusin', (e) => {
      const target = e.target;

      if (target.closest('.mce-window')
          || target.closest('.mce-textbox')
          || target.closest('.tox-dialog')) {
        e.stopImmediatePropagation();
      }
    });
  },

  mounted () {
    this.locale();
    this.tinymce();
  },

  methods: {
    mapFields (fields) {
      const mapped = fields.map((field) => ({
        text: field.description,
        value: `{{ ${field.identifier} }}`,
      }));

      mapped.push({
        text: this.__('Link de Unsubscribe'),
        value: `<a href="{{ unsubscribe_url }}">${this.__('Clique aqui para não receber mais e-mails')}</a>`,
      });

      mapped.push({
        text: this.__('Assinatura do Usuário'),
        value: '{{ user_signature }}',
      });

      mapped.push({
        text: this.__('Ver este email no navegador'),
        value: `<a href="{{ webview_url }}">${this.__('Clique aqui para ver este email no navegador')}</a>`,
      });

      return [ ...mapped, ...invoiceVars ];
    },

    merge (fix, obj) {
      _.each(obj, (item, key) => {
        fix[key] = item;
      });

      return fix;
    },

    tinymce () {
      tinymce.remove();

      tinymce.suffix = '.min';
      tinymce.init(this.merge(this.default, this.config));
    },

    locale () {
      return this.$lang().getLocale();
    },
  },
};
</script>
